import { useState } from "react";
import Cropper from "react-easy-crop";
import { Image as ImageIcon, ImageOff } from "lucide-react"; // Example icons

export default function CropProfileModal({ image, onClose, onSave }) {
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [croppedPixels, setCroppedPixels] = useState(null);

  const onCropComplete = (_, pixels) => {
    setCroppedPixels(pixels);
  };

  const createCroppedImage = async () => {
    const img = new Image();
    img.src = image;
    await new Promise((r) => (img.onload = r));

    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");

    const size = Math.min(croppedPixels.width, croppedPixels.height);
    canvas.width = size;
    canvas.height = size;

    ctx.beginPath();
    ctx.arc(size / 2, size / 2, size / 2, 0, Math.PI * 2);
    ctx.closePath();
    ctx.clip();

    ctx.drawImage(
      img,
      croppedPixels.x,
      croppedPixels.y,
      size,
      size,
      0,
      0,
      size,
      size
    );

    canvas.toBlob((blob) => {
      onSave(blob, canvas.toDataURL("image/png"));
    }, "image/png");
  };

  return (
    <div className="fixed inset-0 z-50 bg-black/60 flex items-center justify-center">
      <div className="mx-4 lg:mx-0 w-[400px] rounded-2xl bg-[#FBF7F1] p-5">
        <h3 className="text-sm font-semibold">Crop Your Profile</h3>
        <p className="text-xs text-gray-500 mt-1">
          For best results, use a PNG, JPG, or GIF image at least 300 x 300 px.
        </p>

        <div className="flex justify-center items-center mt-4">
          <div className="relative h-[300px] w-[300px] rounded-xl overflow-hidden bg-gray-200 flex justify-center items-center">
            <Cropper
              image={image}
              crop={crop}
              zoom={zoom}
              aspect={1}
              cropShape="round"
              showGrid={false}
              onCropChange={setCrop}
              onZoomChange={setZoom}
              onCropComplete={onCropComplete}
            />
          </div>
        </div>

        {/* Range slider with icons */}
        <div className="flex items-center gap-2 mt-4 justify-center">
  <ImageIcon className="text-black-700" size={18} />
  <input
    type="range"
    min={1}
    max={3}
    step={0.1}
    value={zoom}
    onChange={(e) => setZoom(Number(e.target.value))}
    className="h-2 rounded-lg bg-gray-300 accent-black w-[150px]"
    style={{ appearance: 'none' }} // Disables default appearance of the range input
  />
  <ImageIcon className="text-black-700" size={24} />
</div>

{/* Custom range slider thumb styling */}
<style jsx>{`
  input[type="range"]::-webkit-slider-thumb {
    appearance: none;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background-color: white;
    border: 2px solid black;
    cursor: pointer;
  }

  input[type="range"]::-moz-range-thumb {
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background-color: white;
    border: 2px solid black;
    cursor: pointer;
  }
`}</style>


        <div className="mt-5 flex justify-center gap-4">
  <button
    onClick={onClose}
    className="px-5 py-2 rounded-full bg-[#EFE7DA] text-sm w-28"
  >
    Close
  </button>

  <button
    onClick={createCroppedImage}
    className="px-6 py-2 rounded-full bg-black text-white text-sm w-28"
  >
    Save
  </button>
</div>

      </div>
    </div>
  );
}
